import React from 'react';
import { Pagination } from '@trussworks/react-uswds';

export function USWDSPagination(props) {
  return <Pagination {...props} />;
}
